"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REDUX_FORM_NAME = void 0;
exports.REDUX_FORM_NAME = 'record-form';
